import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';

function useToggle(
  initialState: boolean,
): [
    isChecked: boolean,
    handleToggle: () => void,
    setToggle: any,
    reset: () => void,
  ] {
  const [isChecked, setToggle] = useState<boolean>(initialState);

  function handleToggle() {
    setToggle(!isChecked);
  }

  function reset() {
    setToggle(initialState);
  }

  useEffect(() => {
    setToggle(initialState);
  }, [initialState]);

  return [isChecked, handleToggle, setToggle, reset];
}

export default useToggle;

export function useRecoilToggle({
  initial,
  atomState,
  dependency,
}: {
  initial: boolean;
  atomState: any;
  dependency?: any;
}): [
    isChecked: any,
    handleToggle: () => void,
    setAtomForm: any,
    reset: () => void,
  ] {
  const [isChecked, setAtomForm] = useRecoilState<Object>(atomState);

  function handleToggle() {
    setAtomForm((prev) => !prev);
  }

  useEffect(() => {
    setAtomForm(initial);
  }, [dependency]);

  function reset() {
    setAtomForm(initial);
  }

  return [isChecked, handleToggle, setAtomForm, reset];
}
